import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

//config
import defaultConfig from "../../config/Config";

//Utis
import { ToSelectOption, startDownload } from "../../Utils/utils/CommanFnc";
import SelectBox from "../../components/admin/SelectBox";
import Table from "../../components/admin/Table";

//Action 
import moment from "moment";
import { getCityByState, localCurrencyFormater } from "../../services/CommonService";
import { downloadStockReport } from "../../services/reports";
import { getAllState } from "../../slices/InitialDataSlice";
import { getStock } from "../../slices/StockSlice";
import { getUserByType } from "../../slices/UserSlice";
import { Loading } from "../../components/Loading";

export function List() {
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const qStr = Object.fromEntries([...searchParams.entries()])

    // redux state
    const authData = useSelector((state) => state?.auth?.authData);
    const allStates = useSelector((state) => state?.initialData?.StateList);
    const citiesListData = useSelector((state) => state?.initialData?.cityListData);
    const { usersByType } = useSelector((state) => state?.users);
    const { loading, totalCount, list } = useSelector((state) => state?.stock)

    //local state
    const [queryString, setQueryString] = useState(qStr);
    const [assignedState, setAssignedState] = useState([]);
    const [userTypes, setUserTypes] = useState([]);
    const [businessData, setBusinessData] = useState([]);
    const [vendorList, setVendorList] = useState([]);
    const [levelToShowSelect, setLevelToShowSelect] = useState(0);
    const [citiesList, setCitiesList] = useState([])
    const [downloadLoading, setDownloadLoading] = useState(false)
    //const [selectedUserType, setSelectedUserType] = useState('');

    const [defaultParams, setDefaultParams] = useState({
        pageLength: defaultConfig.defaultLimit,
        page: 1
    });
    const columns = useMemo(() => {
        let col = [
            {
                name: 'Shop Name',
                selector: (row) => row?.userShopName,
                sortable: true,
                wrap: true,
                width: '23%',
                center: true
            },
            {
                name: "Product",
                selector: (row) => row?.products?.name,
                sortable: true,
                wrap: true,
                width: '30%',
                center: true
            },
            {
                name: "Quantity",
                selector: (row) => row.quantity,
                sortable: true,
                width: '10%',
                right: true,
            },
            {
                name: "Manufacturing",
                sortable: true,
                center: true,
                cell: (row) => (
                    <>
                        { row.mfg? moment(row.mfg).format(defaultConfig.dateFormat) : '-' }
                    </>
                )
            },
            {
                name: "Expiry",
                sortable: true,
                center: true,
                cell: (row) => (
                    <>
                        {row.expiry? moment(row.expiry).format(defaultConfig.dateFormat) : '-'}
                    </>
                )
            },
            {
                name: "Amount",
                selector: (row) => row?.amount? localCurrencyFormater(row?.amount) : 0,
                sortable: true,
                width: '10%',
                right: true,
            }
        ];

        return col
    }, [])

    useEffect(() => {
        dispatch(getAllState());
        setUserTypes(
            ToSelectOption(
                defaultConfig.orderUserType,
                {
                    value: "value",
                    label: "label"
                }
            )
        )
    }, [])

    useEffect(() => {

        const assignedStateIds = authData.user.assignState;

        setAssignedState(() => {
            const states = authData.user.isMaster === "yes" ? allStates : findAssignedState(allStates, assignedStateIds);
            return ToSelectOption(
                states,
                {
                    value: "_id",
                    label: 'name'
                }
            )
        });

        if (citiesListData) {
            const list = citiesListData.map((item) => {
                return {
                    label: item.name,
                    value: item._id
                }
            })
            setCitiesList(list)
        }

    }, [allStates, authData, citiesListData])

    useEffect(() => {
        let list = []
        if (typeof usersByType !== "undefined") {
            list = usersByType?.map(({ userDetails, _id: userID }) => {
                return {
                    value: userID,
                    label: userDetails.shopName
                }
            })
        }
        setVendorList(list)
    }, [setVendorList, usersByType]);

    useEffect(() => {
        // if (qStr.stateId) {
        //     getVendor({ value: qStr.stateId });
        // }

        // if (qStr.stateId && qStr.userId) {
        //     getStockList({ value: qStr.userId });
        // }

    }, [qStr.userType, qStr.stateId, qStr.userId])

    useEffect(() => {
        setBusinessData({ list, totalCount })
    }, [list, totalCount]);

    function findAssignedState(allStates, assignedStateIds) {
        if (!assignedStateIds || (assignedStateIds.length === 0)) {
            return allStates;
        }
        return allStates.filter((state) => assignedStateIds.indexOf(state._id) > -1);
    }

    const onChangeUserType = function (value) {
        const userType = value ? value : '';
        if (value === 'csa') {
            setLevelToShowSelect(1)
        } else if (value === 'superStockists' || value === 'distributors') {
            setLevelToShowSelect(2)
        } else if (value === 'retailers') {
            setLevelToShowSelect(3)
        }
        const data = { userType };
        const params = Object.assign({ ...defaultParams }, { pageLength: defaultConfig.defaultLimit, page: 1, ...data });
        setBusinessData([]);
        setCitiesList([]);
        setVendorList([]);
        setQueryString(params);
        setSearchParams(params);
    }

    const onStateChange = async function (value) {
        const stateId = value ? value : '';
        const data = { ...queryString, stateId };
        let params = Object.assign({ ...defaultParams }, { pageLength: defaultConfig.defaultLimit, page: 1, ...data });
        setQueryString({ ...queryString, ...{ stateId } });
        setSearchParams(params);
        setCitiesList([]);
        setVendorList([]);
        if (stateId) {
            if (levelToShowSelect === 2) {
                setCitiesList([]);
                const {
                    data: cityList
                } = await getCityByState(stateId);

                setCitiesList(() => {
                    return ToSelectOption(cityList, {
                        value: "_id",
                        label: 'name'
                    })
                });
            } else {
                dispatch(getUserByType(data));
            }
        }

    }

    const onCityChange = function (cityId) {
        const {
            stateId,
            userType
        } = queryString;
        const data = { ...queryString, cityId };
        const params = Object.assign({ ...defaultParams }, { pageLength: defaultConfig.defaultLimit, page: 1, ...data });
        setSearchParams(params);
        setVendorList([]);
        setQueryString({ ...queryString, ...{ cityId } });
        if (userType && stateId && cityId) {
            dispatch(getUserByType(data));
        }
    }

    const getStockList = function (value) {
        const userId = value ? value : '';
        const data = { ...queryString, userId };
        let params = Object.assign({ ...defaultParams }, { pageLength: defaultConfig.defaultLimit, page: 1, ...data });
        setSearchParams(params);
        setBusinessData([]);
        setQueryString({ ...queryString, ...{ userId } });
        const { userType, stateId } = data
        if (userType && stateId && userId) {
            dispatch(getStock({ data: params }));
        }
    }

    const setPaginationData = (paginationData) => {
        const params = { ...defaultParams, page: paginationData.page, pageLength: paginationData.pageLength }
        setSearchParams(params)
    }

    const downloadReport = async () => {
        setDownloadLoading(true)
        const excelData = await downloadStockReport(queryString);
        const timeStamp = new Date().getTime();
        const fileName = `Stock-Report-${timeStamp}.xlsx`
        startDownload(excelData, fileName)
        setDownloadLoading(false)
    }

    return (
        <React.Fragment>
            { downloadLoading? <Loading/>: ''}
            <div className="revenue-wrapper">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card table-card">
                            <div className="d-sm-flex justify-content-between align-items-center pl-4 pr-4">
                                <h4 className="card-title mB25 mb-sm-0"><i className="fas fa-clock"></i> Stock List</h4>
                            </div>
                            <div className="row m-3">
                                <div className="col-sm-10">
                                    <div className="row">
                                        <div className="col-sm-2 p-0 ml-1">
                                            <label className={`d-block`} htmlFor="State">Vendor Type</label>
                                            <SelectBox
                                                placeholder="Select Vendor Type"
                                                options={userTypes}
                                                value={
                                                    userTypes.find(({ value }) => value === queryString.userType)
                                                }
                                                isClearable={true}
                                                onChange={(opt) => onChangeUserType(opt?.value)}
                                            />
                                        </div>
                                        <div className={`col-sm-3 p-0 ml-1 ${levelToShowSelect < 1 ? 'hide' : ''}`}>
                                            <label className={`d-block`} htmlFor="State">State</label>
                                            <SelectBox
                                                placeholder="Select State"
                                                noOptionsMessage={"Select State"}
                                                options={assignedState}
                                                value={
                                                    assignedState.find(({ value }) => value === queryString.stateId) || ''
                                                }
                                                isClearable={true}
                                                onChange={(opt) => onStateChange(opt?.value)}
                                            />
                                        </div>
                                        <div className={`col-sm-3 p-0 ml-1 ${levelToShowSelect < 2 ? 'hide' : ''}`}>
                                            <label className={`d-block`} htmlFor="State">City</label>
                                            <SelectBox
                                                options={citiesList}
                                                isClearable={true}
                                                onChange={(opt) => onCityChange(opt?.value)}
                                                value={citiesList.find(
                                                    (option) => option?.value == queryString.cityId
                                                ) || ''}
                                            />
                                        </div>
                                        <div className={`col-sm-3 p-0 ml-1 ${levelToShowSelect === 0 ? 'hide' : ''}`}>
                                            <label className={`d-block`} htmlFor="State">Shop List</label>
                                            <SelectBox
                                                options={vendorList}
                                                isClearable={true}
                                                value={
                                                    vendorList.find(({ value }) => value === queryString.userId) || ''
                                                }
                                                onChange={(opt) => getStockList(opt?.value)}

                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-2">
                                    <button disabled={ !queryString?.userType || !queryString.stateId} onClick={downloadReport} className="btn btn-success mt-5">
                                        <i className="fa fa-download"></i> Download Stock Report
                                    </button>
                                </div>
                            </div>
                            <Table
                                totalCount={businessData.totalCount}
                                data={businessData.list}
                                columns={columns}
                                dataLoadFnc={getStock}
                                extraConfig={defaultParams}
                                loading={loading}
                                callBack={setPaginationData}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}